import { render, staticRenderFns } from "./provmontura.vue?vue&type=template&id=fa2ff752&"
import script from "./provmontura.vue?vue&type=script&lang=js&"
export * from "./provmontura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports